import AttributesOffNumberField from './AttributesOffNumberField'

export default AttributesOffNumberField
